// ── opening a move-in or a fold from anywhere (components/intake/MovedInArrival) ──
// The inbox, the activity river and netti open the same sheets by event, the way
// the access sheet is opened (lib/self/ringEvents): one host mounted on the
// dashboard listens. Client-safe.

export const OPEN_MOVED_EVENT = 'innernet:open-moved'
export const OPEN_FOLD_EVENT = 'innernet:open-fold'
/** a move-in was kept, let go or taken back: whatever lists them reads again */
export const MOVED_CHANGED_EVENT = 'innernet:moved-changed'

export function movedChanged(run: string): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(MOVED_CHANGED_EVENT, { detail: { run } }))
}

/** open "what moved in" / "what netti folded" for a run (a move-in, or a personal fold) */
export function openMoved(run: string): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(OPEN_MOVED_EVENT, { detail: { run } }))
}

/** open one of netti's project folds */
export function openFold(project: string, commit: string): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(OPEN_FOLD_EVENT, { detail: { project, commit } }))
}

/** the run a link names (`?moved=<run>`), or null */
export function movedOf(link: string | null | undefined): string | null {
  const m = /[?&]moved=([0-9a-f-]{36})/i.exec(link ?? '')
  return m ? m[1] : null
}
